export default __webpack_public_path__ + "static/media/across.a13c794e.svg";